// extracted by mini-css-extract-plugin
export default {"container":"for_kmouR","inner":"for_inn_pgv-o"};